<template>
  <div>
  <v-row dense no-gutters>
    <v-col>
      <v-app-bar
              app
              class="elevation-1 top-bar"
              color="background"
      >

        <router-link :to="{name: 'ResourcesPage'}">
          <v-img
                  src="/vue/dev/app/global/assets/images/logo.png"
                  max-width="200"
                  max-height="40"
                  position="left"
                  contain
                  :class="{'shrinkLogo': $vuetify.breakpoint.smAndDown}"
          ></v-img>
        </router-link>

        <v-spacer></v-spacer>

        &nbsp;
        <v-menu
                offset-y
        >
          <template v-slot:activator="{ on }">

            <v-fab-transition>
              <v-btn
                      color="accent"
                      fab small

                      depressed
                      v-on="on"
                      v-show="show">

                <strong>{{ initials }}</strong>

              </v-btn>
            </v-fab-transition>
          </template>

          <v-list min-width="200">
            <v-list-item dense @click="logout">
              <v-list-item-title>
                <v-icon size="medium" left>fal fa-sign-out</v-icon>
                Sign out
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-app-bar>
    </v-col>
  </v-row>
  <v-row no-gutters dense>
    <v-col cols="12" align-self="start">
        <v-card color="#F6F8FB" class="lower-top-bar px-0" flat height="55px">
          <v-row no-gutters dense justify="start" class="fill-height">
            <v-col cols="3" sm="2" align-self="end">
              <v-btn @click="goBack" icon class="mb-1">
                <v-icon
                        v-if="$route.meta.backRoute"
                        size="18"
                        primary--text
                        primary
                        class="primary--text"
                >
                  fas fa-chevron-left
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6" sm="8" align-self="end">
              <v-list-item-title class="pr-4 mb-2">
                <h4 class="text-center primary--text">
                  {{ $route.meta.title }}
                </h4>
              </v-list-item-title>
            </v-col>
            <v-col cols="3" sm="2" align-self="end">
              <v-spacer></v-spacer>
            </v-col>
          </v-row>
        </v-card>
    </v-col>
  </v-row>
  </div>
</template>

<script>
  export default {
  data() {
    return {};
  },
  computed: {
    initials() {
      const { firstName, lastName } = this.parent;
      return `${firstName.charAt(0)}${lastName.charAt(0)}`;
    },
    show() {
      return this.initials.length > 0;
    },
    parent() {
      return this.$store.getters.parent;
    },

    history() {
      return window.history.length > 0;
    },
  },

  methods: {
    goBack() {
      if (this.$route.meta.backRoute && this.$route.meta.backRoute.constructor === String) {
        return this.$router.push({ name: this.$route.meta.backRoute });
      }
      this.$router.go(this.$route.meta.backRoute);
    },
    logout() {
      window.location.href = '/logout';
    },
  },
  components: {},
  created() {},
  updated() {},
};
</script>

<style lang="scss" scoped>

  .top-bar {
    border-bottom: 1px solid var(--v-form-border-base);
    z-index: 11;
  }

  .v-application .pr-4 {
    padding-right: 0px !important;
  }

  .lower-top-bar {
    position: fixed;
    top: 50px;
    width: 100%;
    z-index: 10;
  }
  .shrinkLogo {
    width: 100px;
  }
</style>
